import { PendoAnalytics } from '@/directives/analytics/pendo-analytics';
import { hasSlot } from '@/utils/utils';

export default {
    directives: {
        PendoAnalytics
    },
    props: {
        /**
         * Label text, placed on top of component by default
         */
        label: {
            type: String,
            default: null
        },
        /**
         * Label position, used in combination with `label` prop
         */
        labelPosition: {
            type: String,
            default: 'top',
            validator: (position) => ['top', 'bottom', 'left', 'right'].includes(position)
        },
        /**
         * pass multiple labels in the form of
         * `:labels="{ top: 'label text', bottom: 'label text', suffix: 'label text'}"`
         */
        labels: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        hasTopLabel () {
            return this.topLabel || hasSlot(this, 'topLabel');
        },
        hasBottomLabel () {
            return this.bottomLabel || hasSlot(this, 'bottomLabel');
        },
        hasRightLabel () {
            return Boolean(this.labelPosition === 'right' || this.labels.right);
        },
        hasLeftLabel () {
            return Boolean(this.labelPosition === 'left' || this.labels.left);
        },
        topLabel () {
            if (this.label && ['top', 'left'].includes(this.labelPosition)) {
                return this.label;
            }

            return this.labels.top || this.labels.left;
        },
        bottomLabel () {
            if (this.label && ['bottom', 'right'].includes(this.labelPosition)) {
                return this.label;
            }

            return this.labels.bottom || this.labels.right;
        },
        inlineLabel () {
            return this.hasRightLabel || this.hasLeftLabel;
        },
        suffixLabel () {
            if (this.label && this.labelPosition === 'suffix') {
                return this.label;
            }

            return this.labels.suffix;
        },
        analyticsTagFromLabels () {
            const tag = [];

            if (this.topLabel) {
                tag.push(this.topLabel);
            }

            if (this.bottomLabel) {
                tag.push(this.bottomLabel);
            }

            if (this.inlineLabel) {
                tag.push(this.inlineLabel);
            }

            return tag.join(' ');
        }
    }
};
